import ConnectivityErrorModal from './ConnectivityErrorModal';

export default ConnectivityErrorModal;
